// @flow
import { PureComponent } from 'react';
import { Dispatch } from 'redux';

import { showCustomNotification, hideCustomNotification } from './actions';


export type Props = {
    customNotification: Object | null
};

export default class AbstractCustomNotification<P: Props> extends PureComponent<P> {
    constructor(props: P) {
        super(props);
    }
}

/**
 * Maps (parts of) the redux state to the associated props for this component.
 *
 * @param {Object} state - The Redux state.
 * @param {Props} ownProps - The own props of the Component.
 * @private
 * @returns {Props}
 */
export function _mapStateToProps(state) {
    const { customNotification } = state['wildix/features/notifications'];

    return {
        customNotification
    };
}


/**
 * Maps dispatching of some action to React component props.
 *
 * @param {Function} dispatch - Redux action dispatcher.
 * @private
 * @returns {{
 *     showCustomNotification: Function,
 *     hideCustomNotification: Function
 * }}
 */

export function _mapDispatchToProps(dispatch: Dispatch<any>) {
    return {
        onShowCustomNotification: () => {
            dispatch(showCustomNotification());
        },
        onHideCustomNotification: () => {
            dispatch(hideCustomNotification());
        }
    };
}

